import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import piSiteDetails from "./components/pi-site-details/pi-site-details.vue";
import piSiteStepsRecord from "./components/pi-site-steps-record/pi-site-steps-record.vue";
import tabsContent from "@/components/tabs-content/tabs-content.vue";
import i18n from "@/config/i18n";
let PiSiteDetails = class PiSiteDetails extends Vue {
    constructor() {
        super(...arguments);
        this.tabsList = [
            { value: "tab1", title: i18n.t("pileInfoDetail.tab1") },
            { value: "tab2", title: i18n.t("pileInfoDetail.tab2") },
        ];
        this.tabsActive = "tab1";
        this.isTabs1 = false;
        this.isTabs2 = false;
        this.staPkId = "";
    }
    tabChange(data) {
        if (data == "tab2" && !this.isTabs2) {
            this.isTabs2 = true;
        }
        this.tabsActive = data;
    }
    activated() {
        let query = this.$route.query || {};
        if (this.staPkId != query.staPkId) {
            this.isTabs1 = false;
            this.isTabs2 = false;
            this.tabsActive = "tab1";
            setTimeout(() => {
                this.staPkId = query.staPkId;
                this.isTabs1 = true;
                this.isTabs2 = false;
            }, 100);
        }
    }
};
PiSiteDetails = __decorate([
    Component({
        components: {
            "pi-site-details": piSiteDetails,
            "pi-site-steps-record": piSiteStepsRecord,
            "pi-tabs-content": tabsContent,
        },
    })
], PiSiteDetails);
export default PiSiteDetails;
